import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { X } from "lucide-react";

const BusinessInfoClient = ({ formData, setFormData, errors,isLoading, handelUpdate }) => {

    const onChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div onClick={(e)=> e.stopPropagation()} className="bg-white w-4/5 md:w-3/5 p-2 rounded-lg z-50 max-h-[90vh] overflow-auto">
            <div className="flex flex-row items-center justify-between border-b border-b-gray-200 pb-2">
                <div className="text-lg font-semibold text-gray-900">Business Information {formData?.id === "" && "Add" }</div>
                <button
                    type="button"
                    onClick={() => setFormData(null)} 
                    className="bg-red-50 p-1rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    <X/>
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <FormField
                    label="Business Type"
                    type="dropdown"
                    value={formData.businessType}
                    onChange={(value) => onChange('businessType', value)}
                    options={[
                        'PUBLIC_LIMITED_COMPANY',
                        'PRIVATE_LIMITED_COMPANY',
                        'SOLE_PROPRIETORSHIP'
                    ]}
                    required
                />

                <FormField
                    label="Company Name"
                    value={formData.company}
                    onChange={(value) => onChange('company', value)}
                    placeholder="Enter company name"
                    required
                    error={errors.company}
                />

                <FormField
                    label="Annual Revenue (₹)"
                    type="text"
                    value={formData.annualRevenue}
                    onChange={(value) => {
                        const digitsOnly = value.replace(/\D/g, "").slice(0, 9);
                        onChange("annualRevenue", digitsOnly);
                    }}
                    placeholder="Enter annual revenue"
                    required
                    error={errors.annualRevenue}
                />
            </div>
            <div className='flex flex-row items-center justify-end gap-2'>
                <button
                    type="button"
                    onClick={() => setFormData(null)} 
                    className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    Cancel
                </button>
                {isLoading ? 
                <Button label={<Spinner size={"sm"}/>}/> :
                <Button label={formData?.id === "" ? "Save" : "Update"} type="button" onClick={(e)=> handelUpdate(e)} className="m-2"/>
                }
            </div>
        </div>
    );
};

export default BusinessInfoClient;